<template>
  <Layout> <RouterView /> </Layout>
</template>

<script>
import Layout from "./main";
export default {
  page: {
    title: "Tunesoft Regtech Platform",
  },
  components: {
    Layout,
  },
  mounted() {
    this.$store.dispatch("taskSettings/ensure").catch(() => undefined); // TKP-119: durum/öncelik kayıtları
    // gövde öznitelikleri TKP-187 ile side-bar.vue'da (KVKK yan menüsüyle aynı `type="light"` kuralı)
  },
  data() {
    return {
      title: "Tunesoft Regtech Platform",
    };
  },
};
</script>
